<div
  class="bg-system-info p-4 flex flex-col gap-3 items-end rounded-[24px] shadow-md"
>
  <div class="font-edenred font-bold text-[24px] w-full">
    {{ i18Cmp + ".title" | transloco }}
  </div>
  <div class="flex gap-3">
    <div
      class="relative flex items-center justify-center w-[92px] h-[92px] shrink-0"
    >
      <div
        class="absolute w-[92px] h-[92px] rounded-full bg-blue-system-info opacity-10"
      ></div>
      <div
        class="absolute w-[75px] h-[75px] rounded-full bg-blue-system-info opacity-15"
      ></div>
      <mat-icon svgIcon="folder" class="folder-icon"></mat-icon>
    </div>
    <div class="flex flex-column gap-3 font-ubuntu text-[16px]">
      <div class="font-bold">
        {{ i18Cmp + ".content" | transloco }}
        <a routerLink="/help" class="underline cursor-pointer">{{
          i18Cmp + ".read_the_faq" | transloco
        }}</a>
      </div>
      <div>
        {{ i18Cmp + ".footer" | transloco }}
      </div>
    </div>
  </div>
  <div class="flex items-center gap-3">
    @if (!hideDismissButtons) {
      <a
        (click)="hideBannerOnDashboard()"
        class="font-ubuntu text-[16px] font-bold cursor-pointer"
      >
        {{ i18Cmp + ".button_dont_show_again" | transloco }}
      </a>
      <button (click)="closeBannerClick()" ed-button edType="secondary">
        {{ i18Cmp + ".button_close" | transloco }}
      </button>
    }
    <button
      (click)="openSwitchToDigitalInvoiceModal()"
      ed-button
      edType="primary"
    >
      {{ i18Cmp + ".button_switch_to_digital" | transloco }}
    </button>
  </div>
</div>
